//#region Styles
import { Row } from "components/styles";
//#endregion
//#region Components
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
//#endregion
//#region Utils
import { handlerKeyPressOnlyNumbers, handlerKeyPressOnlyNumbersAndLetters } from "utils/validations";
//#endregion

const FreeEnvironmentControls = ({
    form, changeField,
    errors
}) => {
    const { envName, address, floor, capacity } = form;
    //#region Functions
    const changeEnvName = value => {
        changeField("envName", value, false);
    }
    const changeAddres = value => {
        changeField("address", value, false);
    }
    const changeFloor = value => {
        changeField("floor", value, false);
    }
    const changeCapacity = value => {
        changeField("capacity", value, false);
    }
    //#endregion
    return (
        <Row justifyContent="flex-start">
            <CustomTextInput
                label="Otro ambiente"
                value={envName}
                placeholder="Ingresa el ambiente"
                onChange={changeEnvName}
                error={errors.envName}
                errorText="Es necesario un ingresar un ambiente"/>
            <CustomTextInput
                label="Dirección"
                value={address}
                placeholder="Ingresa la dirección"
                onChange={changeAddres}
                error={errors.address}
                errorText="Es necesario ingresar una dirección"
                minWidth="350px"/>
            <CustomTextInput
                label="Piso"
                value={floor}
                placeholder="Ingresa el piso"
                onChange={changeFloor}
                onKeyPress={handlerKeyPressOnlyNumbersAndLetters}
                error={errors.floor}
                errorText="Es necesario ingresar un piso"
                minWidth="150px"/>
            <CustomTextInput
                label="Capacidad"
                value={capacity}
                onChange={changeCapacity}
                placeholder="Ingresa la capacidad"
                onKeyPress={handlerKeyPressOnlyNumbers}
                error={errors.capacity}
                errorText="Es necesario ingresar una capacidad"
                minWidth="150px"/>
        </Row>
    );
}

export default FreeEnvironmentControls;